import { Controller } from "stimulus";

export default class extends Controller {
    initialize() {
        super.initialize();
        this.initWeglot();
        this.boundRefreshPaths = this.refreshPathsOnNavigation.bind(this);
        document.addEventListener("turbolinks:load", this.boundRefreshPaths);
    }

    disconnect() {
        document.removeEventListener("turbolinks:load", this.boundRefreshPaths);
    }

    connect() {
        try {
            const controller = this;
            Weglot.on("initialized", function() {
                controller.updateLinksPath(Weglot.getCurrentLang());
            });
            Weglot.on("languageChanged", function(newLang, prevLang) {
                controller.updateSwitcherPath();
                controller.updateLinksPath(newLang);
            });
            Weglot.on("switchersReady", function(initialLanguage) {
                controller.updateSwitcherPath();
            });
        } catch (e) {
            console.error("Error initializing Weglot:", e);
        }
    }

    refreshPathsOnNavigation() {
        const controller = this;
        controller.registerEvents();

        // Weglot may inject switcher DOM asynchronously; refresh again after a short delay
        setTimeout(() => {
            controller.registerEvents();
        }, 150);
    }

    registerEvents() {
        const controller = this;
        document.querySelector(".weglot_switcher")?.addEventListener("click", () => controller.updateSwitcherPath());
    }

    initWeglot() {
        Weglot.initialize({
            api_key: atob(window.WEGLOT_API_KEY),
            cache: true,
            switchers: [
                {
                    style: {
                        is_dropdown: true,
                        with_flags: false,
                    }
                }
            ],
            autoSwitch: false
        });
    }

    getUpdatedPath(path, language, search = location.search, hash = location.hash) {
        language = language?.replace(/en/, '');
        path = path.replace(/^\/[a-z]{2}(?=\/|$)/, '');

        if (path.endsWith('/'))
            path = path.slice(0, -1);

        if (language) {
            path = `/${language}${path}`;
        } else if (!path) {
            path = '/';
        }

        return path + search + hash;
    }

    updateLinksPath(language) {
        document.querySelectorAll('a[href*="beambox.com"]').forEach(anchor => {
            const excluded = ['help.beambox.com', 'status.beambox.com'];
            const url = new URL(anchor.href, window.location.origin);

            if (excluded.includes(url.hostname)) return;

            url.searchParams.delete('locale');

            anchor.href = this.getUpdatedPath(url.pathname, language, url.search, url.hash);
        });
    }

    updateSwitcherPath() {
        const controller = this;
        document.querySelectorAll('a[id^="weglot-language-"]').forEach(anchor => {
            const url = new URL(controller.getUpdatedPath(location.pathname, anchor.lang), location.origin);
            anchor.setAttribute("href", url.href);
        });
    }
}
